import axiosConfig from "../../../config/axiosConfig";
import { createQueryParams, getStringFromArray } from "../../../utils/helper";
import {
  FLIPTRADE_URL,
  CUSTOMER_VENDER_URL,
  DELETE_PART_ROW_URL,
  PART_NUMBER_URL,
} from "../../../config/config";

export const GetFliptradeService = (params) => {
  try {
    const { filters, ordering, page, per_page } = params || {};
    const paramList = {
      ordering,
      trade_id: filters?.trade_id,
      customer_id: filters?.customer_id?.value,
      status: getStringFromArray(filters?.status),
      created_at: filters?.created_at,
      page,
      per_page,
    };
    const queryString = createQueryParams(paramList);
    const url = `${FLIPTRADE_URL}${queryString ? `?${queryString}` : ""}`;
    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

export const AddFliptradingService = (data) => {
  return axiosConfig.post(`${FLIPTRADE_URL}`, data);
};

export const UpdateFliptradingService = (data) => {
  return axiosConfig.patch(`${FLIPTRADE_URL}`, data);
};

// DropDown for Vendor and Customer
export const GetCustomerService = (data) => {
  try {
    const {
      is_customer,
      column = "name",
      search_by,
      per_page,
      page,
    } = data || {};
    const paramList = { column, is_customer, search_by, page, per_page };
    const queryString = createQueryParams(paramList);
    const url = `${CUSTOMER_VENDER_URL}${queryString ? `?${queryString}` : ""}`;
    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

export const GetPartNumberService = (data) => {
  try {
    const { search_by, per_page, page } = data || {};
    const paramList = { pn: search_by, page, per_page };
    const queryString = createQueryParams(paramList);
    const url = `${PART_NUMBER_URL}${queryString ? `?${queryString}` : ""}`;
    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

export const GetVendorService = (data) => {
  try {
    const { is_customer, column = "name", page, per_page } = data || {};
    const paramList = { column, is_customer, page, per_page };
    const queryString = createQueryParams(paramList);
    const url = `${CUSTOMER_VENDER_URL}${queryString ? `?${queryString}` : ""}`;
    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

// Deleting the Parts row [PATCH]

export const DeletePartsRowService = (data) => {
  const { id } = data;
  return axiosConfig.delete(`${DELETE_PART_ROW_URL}/${id}`);
};
